import { useNavigate, useLocation } from "react-router-dom";

const useAuthHandler = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const params = new URLSearchParams(location.search);

    const allowGuest =
        !!params.get("allowGuest") &&
        params.get("allowGuest").toLowerCase() === "true";
    const campaign = params.get("campaign");
    const targetOrigin = params.get("targetOrigin");

    const authHandler = () => {
        // Redirect to login and pass variables if they exist

        const queryParams = [
            { name: "allowGuest", value: allowGuest },
            { name: "campaign", value: campaign },
            { name: "targetOrigin", value: targetOrigin },
        ];

        const query = queryParams
            .filter((param) => param.value != null)
            .map((param) => `${param.name}=${param.value}`);

        navigate(`/login${query ? `?${query.join("&")}` : ""}`);
    };

    return { authHandler };
};


export default useAuthHandler